import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditJobwork = () => {
    const [description, setDescription] = useState('');
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [existingImage, setExistingImage] = useState('');
    const navigate = useNavigate();
    const { id } = useParams(); // Get the jobwork ID from the URL

    // Fetch the jobwork details when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}jobwork/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setDescription(data.data.description);
                    setExistingImage(data.data.image); // Set the existing image URL
                } else {
                    alert('Error fetching jobwork data');
                }
            })
            .catch(error => console.error('Error fetching jobwork:', error));
    }, [id]);

    // Handle description change
    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    // Handle image change
    const handleImageChange = (event) => {
        setImage(event.target.files[0]);
    };

    // Handle form submission for updating jobwork
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('description', description);
        if (image) {
            formData.append('image', image);
        }

        fetch(`${BASE_URL}jobwork/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if (data.status === 1) {
                    alert('Jobwork updated successfully');
                    navigate('/JobworkList'); // Redirect to the Jobwork List page
                } else {
                    alert('Error updating jobwork');
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error updating jobwork:', error);
                alert('An error occurred while updating the jobwork');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Jobwork</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Jobwork</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            className="form-control"
                                            placeholder="Enter jobwork description"
                                            value={description}
                                            onChange={handleDescriptionChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={handleImageChange}
                                        />
                                    </div>

                                    {existingImage && (
                                        <div className="mb-3">
                                            <label>Current Image</label>
                                            <br />
                                            <img
                                                src={`${BASE_URL}${existingImage}`}
                                                alt="Current Jobwork"
                                                width="100"
                                                height="100"
                                            />
                                        </div>
                                    )}

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Updating...' : 'Update Jobwork'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditJobwork;
